import { onError } from '@apollo/client/link/error';
export var ErrorLink = onError(function (_ref) {
  var graphQLErrors = _ref.graphQLErrors,
    networkError = _ref.networkError;
  if (graphQLErrors) graphQLErrors.map(function (_ref2) {
    var message = _ref2.message,
      locations = _ref2.locations,
      path = _ref2.path;
    return console.log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
  });
  if (networkError) console.log("[Network error]: ".concat(networkError));
});